import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  form: null,
  redirectTo: null,
  redirectTriggered: false,
};

const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    clearForm(state) {
      return initialState;
    },
    storeRedirect(state, action) {
      state.redirectTo = action.payload;
    },
    clearPlantDesignForm(state) {
      return state;
    },
    clearPlantItemRenewalForm(state) {
      return state;
    },
  },
});

export const { clearForm, storeRedirect, clearPlantDesignForm, clearPlantItemRenewalForm } = formSlice.actions;
export const formReducer = formSlice.reducer;
